import {isApiException} from '@dms/api/utils';

import {ApiError, isFetchBaseQueryError} from 'shared/web';

/**
 * A conflicting block is rejected outright (nothing is auto-cancelled), so these two codes -
 * both returned by create and edit - must be surfaced as a dialog the user has to read and
 * acknowledge, not a toast that can be missed.
 */
const BLOCK_CONFLICT_ERROR_CODES = ['DMS-CR-RVB-0003', 'DMS-CR-RVB-0004'];

export function getBlockConflictErrorMessage(error: ApiError) {
  if (!isFetchBaseQueryError(error) || !isApiException(error.data)) {
    return null;
  }

  return (
    error.data.errors.find((apiError) => BLOCK_CONFLICT_ERROR_CODES.includes(apiError.code))
      ?.message ?? null
  );
}
